import { render } from "./whatWeOffer.vue?vue&type=template&id=579d8314&scoped=true"
import script from "./whatWeOffer.vue?vue&type=script&lang=js"
export * from "./whatWeOffer.vue?vue&type=script&lang=js"

import "./whatWeOffer.vue?vue&type=style&index=0&id=579d8314&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579d8314"]])

export default __exports__